import React from "react";
import { ContactForm } from "../components/ContactForm";

import LucidImg from "../assets/graphics/lucid.png";
import SpacerImg from "../assets/images/spacer.png";
import QuotesIcon from "../assets/icons/quotes.png";

import "./about.scss";
import { Helmet } from "react-helmet";

export function AboutPage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <header className="page-header">
        <div>
          <h3 className="mainSubhead white">Manufacturing simplicity</h3>
          <p className="body-text white">
            More than our tagline: it drives all we do.
          </p>
        </div>
        <div>
          <img src={LucidImg} className="header-img" alt="Lucid" />
        </div>
      </header>

      <div>
        <div className="about-container">
          <div>
            <h3 className="mainSubhead centre">
              Transforming real-world experience
            </h3>
            <p className="body-text">
              Alpaca leverages 35 years of manufacturing, implementation, and
              software experience to redefine ERP program implementation and
              help customers discover opportunities. Our team of project
              managers, developers, solution architects, and software experts
              apply their deep expertise and understanding of manufacturing
              business processes to help clients successfully implement the
              right solution that reduces costs, optimizes workflows, and
              increases profits.
            </p>
          </div>
        </div>

        <div className="alpaca-about-section">
          <img src={SpacerImg} className="about-section-img" alt="Spacer" />
          <div>
            <h3 className="mainSubhead centre">
              Utilizing real-world manufacturing experience
            </h3>
            <p className="body-text">
              In 2021, Alpaca launched the Lucid suite of solutions and the
              flagship PowerPlanner, a game-changer in manufacturing and
              production that streamlines planning, resources, and asset
              allocation.
              <br />
              <br />
              Lucid was born during Alpaca’s journey working with a sister
              company and manufacturer, Steelhaus Technologies, and setting up a
              ground-up, fully vertically integrated 200,000 sq. ft.
              manufacturing business.
            </p>
          </div>
        </div>
      </div>

      <div className="shane-pullquote">
        <img src={QuotesIcon} className="quotemarks" alt="Quote Marks" />
        <blockquote>
          <p className="body-text left">
            Not only did we find that there were very few implementers in the
            market who specialized in or had practical manufacturing experience,
            we also found that the out-of-the-box ERP programs didn’t translate
            to an efficient manufacturing operation without extensive, costly
            and frustrating customizations. Our goal became clear: we needed to
            create our own affordable, easy to implement solution that serves as
            the foundation application and will fit within any growing
            manufacturing businesses. The result was the Lucid manufacturing
            suite of solutions.
          </p>
          <p className="quote-name">- Shane, Steelhaus Technologies</p>
        </blockquote>
      </div>

      <ContactForm />
    </>
  );
}
